module.exports = __webpack_public_path__ + "static/media/queuing.ce3158d3.png";